import { render, staticRenderFns } from "./sukien.vue?vue&type=template&id=25352d4f"
import script from "./sukien.vue?vue&type=script&lang=js"
export * from "./sukien.vue?vue&type=script&lang=js"
import style0 from "./sukien.vue?vue&type=style&index=0&id=25352d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports